const ChatWidget = () => {
    return (
        <chat-widget
            location-id="PLouWMQLEM9Cjar4zCvw"
            style={{ "chatWidgetActiveColor": "#00649e", "chatWidgetPrimaryColor": "#00649e"}}
            legal-msg="By submitting you agree to receive SMS or e-mails for the provided channel."
            show-prompt="false"
            use-email-field="true"
            support-contact="info@foundersinsulation.com"
            locale="en-us"
            primary-color="#00649e">
        </chat-widget>
    );
};

export default ChatWidget;